
/**
 * Higher Order Component that evaluates if `props.hostProps().activeChildItem` is the current. If so, it activates
 * scrollIntoView animation to focus the UI element for the user, and passes the prop `activate:boolean` downwards
 */
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { deepEquals } from 'app/infrastructure/js';

export const Activator: React.FC<any> = (props) => {
  const elementRef = useRef<any>(null);
  const [lastActiveChildItem, setLastActiveChildItem] = useState<any>(undefined);

  const isActive = useMemo(() => {
    const { activeChildItem } = props;

    if (activeChildItem && props.resolveContext.path && props.resolveContext.path.length > 1) {
      const partialPath = activeChildItem.slice(0, props.resolveContext.path.length);
      return deepEquals(props.resolveContext.path, partialPath);
    }
    return false;
  }, [window.location.href, props.resolveContext.path]);

  const shouldActivateItself = () => {
    const { activeChildItem } = props;
    const hasChanged = !deepEquals(lastActiveChildItem, activeChildItem);
    return hasChanged && isActive;
  };

  const activateIfNeeded = () => {
    const { activeChildItem } = props;
    if (shouldActivateItself() && elementRef.current) {
      setLastActiveChildItem(activeChildItem);
    }
  };

  const { router, route, history } = props;

  const children = useMemo(() =>
    React.cloneElement(React.Children.only(props.children as any), { router, route, history, ...{ activate: isActive } 
    }), [props.children, isActive]);

  useEffect(() => {
    activateIfNeeded();
  }, [props]);
  
  return (
    <div ref={elementRef}>
      {children}
    </div>
  );
};
